import React, { Component } from 'react';
import './Common.css';
import './TextCurrencyInput.css';

class TextCurrencyInput extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.convertEthToUsd = this.convertEthToUsd.bind(this);
    }

    changeTextInput(event) {
        this.props.onChange(event);
    }

    convertEthToUsd(value) {

        let ethPrice = this.props.ethPrice;
  
        let usdStr = "";
        if(value !== "" && value !== null && /^[0-9]+\.?[0-9]*?$/i.test(value) && ethPrice && ethPrice.hasOwnProperty("USD")) {
  
          let usdPerEth = ethPrice.USD;
          let usdFloat = parseFloat(value) * usdPerEth;
  
          if(!isNaN(usdFloat)) {
            usdStr = "$" + usdFloat.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " USD";
          }
        }
        
        return usdStr;
    }

    render() {  

        return (
            <div className={this.props.outerClassName} style={{position: "relative"}} >
                <input disabled={this.props.disabled} style={{position: "relative", zIndex:"2", backgroundColor:"transparent"}} placeholder={this.props.placeholder} type="text" className={this.props.className +  (this.props.disabled ?" disabled" : "")} name={this.props.name} value={this.props.value} onChange={this.changeTextInput} />
                <div style={{zIndex:(this.props.disabled ? "2" : "")}} className={this.props.value === "" ? "hide" : "inputLeftSideExplainer"}><span style={{color:"#fff", visibility:"hidden"}}>{this.props.value}&nbsp;</span><span>ETH</span></div>
                <div style={{zIndex:(this.props.disabled ? "2" : "")}} className={this.props.value === "" ? "hide" : "inputRightSideExplainer"}>{this.convertEthToUsd(this.props.value)}</div>
            </div>

        );
    }
  }
  
  export default TextCurrencyInput;


// WEBPACK FOOTER //
// ./src/components/TextCurrencyInput.js